import { CountryIsoCode } from '$provider/constants/CountryIsoCode';
import type { CountryModel } from '$provider/models/CountryModel';

class CountryData {
  private list: CountryModel[] = [];

  public get hasList(): boolean {
    return this.list.length > 0;
  }

  public getLabel(id: string): string {
    return this.list.find((item) => item.id === id)?.name || '';
  }

  public isUSA(id: string): boolean {
    return this.list.find((item) => item.id === id)?.isoCode === CountryIsoCode.USA;
  }

  public getAsCommonList(): CommonList[] {
    return this.list.map((item: CountryModel) => item.toCommonList());
  }

  public setCountries(list: CountryModel[]): void {
    this.list = list;
  }

  public reset(): void {
    this.list = [];
  }
}

export const countryData = new CountryData();
